import { render, staticRenderFns } from "./WithdrawFTMConfirmation.vue?vue&type=template&id=04e5d3b2&"
import script from "./WithdrawFTMConfirmation.vue?vue&type=script&lang=js&"
export * from "./WithdrawFTMConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports